import Modal from "../../components/modal/modal";
import React, {useEffect, useState} from "react";
import styles from './index.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faX} from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../AxiosInstance";

function MenuBox({ valueIndex, name, field, active, index, onChange, onRemove }) {

    const switchShow = () => {
        onChange(index, 'show', !active);
    };

    const remove = () => {
        onRemove(index);
    };

    return (
        <div className={styles.menuBoxContainer} style={{
            userSelect: 'none',
            color: '#4B5563',
        }}>
            <input
                value={valueIndex}
                onChange={(e) => onChange(index, 'index', e.target.value)}
                placeholder={'0'}
                type="number"
            />
            <input
                value={name}
                onChange={(e) => onChange(index, 'name', e.target.value)}
                placeholder={'Nombre'}
            />
            <input
                value={field}
                onChange={(e) => onChange(index, 'field', e.target.value)}
                placeholder={'campo'}
            />
            <div style={{cursor: 'pointer', textAlign: 'center'}} onClick={switchShow}>
                {active ?
                    <div style={{borderRadius: '6px', color: '#FFF', backgroundColor: '#209118', fontWeight: 600}}>Activo</div>
                    :
                    <div style={{borderRadius: '6px', color: '#FFF', backgroundColor: '#f34933', fontWeight: 600}}>Inactivo</div>
                }
            </div>
            <div className={'d-flex align-items-center justify-content-center'}>
                <FontAwesomeIcon icon={faX} color={"#f34933"} onClick={remove} style={{cursor: 'pointer'}}/>
            </div>
        </div>
    );
}

export default function PurchaseOrderSettings({show, setter, data}) {
    const [form, setForm] = useState([]);
    const [locked, setLocked] = React.useState(false);
    const defaultField = { name: "", field: "", show: false };

    const submit = async () => {
        if(locked) return;
        setLocked(true);

        await axiosInstance.post('company/save_purchase_order_config/', {
            purchase_order_config: form
        });

        window.location.reload();
    }

    const handleChange = (index, field, value) => {
        setForm(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const handleRemove = (indexToRemove) => {
        setForm(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    useEffect(() => {
        setForm(data);
    }, [show, data])

    return (
        <Modal show={show} setter={setter} name={'Configurar Ordenes de Compra'} buttonName={'Guardar'} onClick={submit}>
            <div className={styles.menuBoxContainer}>
                <b>Orden</b>
                <b>Campo</b>
                <b>Mostrar</b>
                <b>Eliminar</b>
            </div>

            {form.map((item, index) => {
                return (
                    <MenuBox
                        key={index}
                        index={index}
                        valueIndex={item.index}
                        name={item.name}
                        field={item.field}
                        active={item.show}
                        onChange={handleChange}
                        onRemove={handleRemove}
                    />
                )
            })}

            <div className={'d-flex justify-content-center'}>
                <div onClick={() => setForm(prev => [...prev, { ...defaultField }])}
                    className={`${styles.modalButton} d-flex align-items-center mt-3`} style={{backgroundColor: "#4B5563"}}>
                    <FontAwesomeIcon icon={faPlus} className={'pe-2'}/>
                    Nuevo Campo
                </div>
            </div>
        </Modal>
    )
}